import * as constants from './constants'

export const processStarted = (...names) => ({
    type: constants.PROCESS_STARTED,
    names,
})

export const processCompleted = (...names) => ({
    type: constants.PROCESS_COMPLETED,
    names,
})

export const processFailed = (error, ...names) => ({
    type: constants.PROCESS_FAILED,
    error,
    names,
})

export const clearPending = names => ({
    type: constants.CLEAR_PENDING,
    names,
})
